import { render } from "./distribute-dialog.vue?vue&type=template&id=1aa9e261&scoped=true"
import script from "./distribute-dialog.vue?vue&type=script&lang=js"
export * from "./distribute-dialog.vue?vue&type=script&lang=js"

import "./distribute-dialog.vue?vue&type=style&index=0&id=1aa9e261&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa9e261"]])

export default __exports__